import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppContext from "app/appContext";
import GullLayout from "app/GullLayout/GullLayout";
import { flatMap } from "lodash";
import permissionsService from "../services/permissionsService";
import localStorageService from "../services/localStorageService";

/**
 * Hay sesión si el login guardó el usuario en el navegador. Sin esto, cualquier
 * URL abierta directo (link, favorito, otro navegador) cargaba la pantalla sin
 * usuario y las que leen el rol se rompían.
 */
const hasSession = () => {
  const user = localStorageService.getItem("auth_user");
  return !!(user && user.email_user);
};

class AuthGuard extends Component {
  constructor(props, context) {
    super(props);
    let { routes } = context;

    this.state = {
      authenticated: hasSession(),
      permissionGranted: true,
      routes
    };
  }

  componentDidMount() {
    this.setState({
      routes: flatMap(this.state.routes, item => {
        if (item.routes) {
          return [...item.routes];
        }
        return [item];
      })
    });

    if (!this.state.authenticated) {
      this.redirectRoute(this.props);
    } else if (!this.state.permissionGranted) {
      this.redirectDenied(this.props);
    }
  }

  componentDidUpdate() {
    if (!this.state.authenticated) {
      this.redirectRoute(this.props);
    } else if (!this.state.permissionGranted) {
      this.redirectDenied(this.props);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.authenticated !== this.state.authenticated ||
      nextState.permissionGranted !== this.state.permissionGranted
    );
  }

  static getDerivedStateFromProps(props, state) {
    const { location, user } = props;
    const { pathname } = location;
    const matched = state.routes.find(r => r.path === pathname);
    const authenticated =
      hasSession() &&
      (matched && matched.auth && matched.auth.length
        ? matched.auth.includes(user && user.role)
        : true);
    const permissionGranted =
      pathname === "/dashboard/v1" || permissionsService.canView(pathname);

    return {
      authenticated,
      permissionGranted
    };
  }

  redirectRoute(props) {
    const { location, history } = props;
    const { pathname, search } = location;

    // Al loguearse vuelve a la URL que quería abrir (ver LoginActions).
    history.push({
      pathname: "/session/signin",
      state: { redirectUrl: `${pathname}${search || ""}` }
    });
  }

  redirectDenied(props) {
    props.history.push({ pathname: "/dashboard/v1" });
  }

  render() {
    let { route } = this.props;
    const { authenticated, permissionGranted } = this.state;

    return authenticated && permissionGranted ? (
      <Fragment>
        <GullLayout route={route}></GullLayout>
      </Fragment>
    ) : null;
  }
}

AuthGuard.contextType = AppContext;

const mapStateToProps = state => ({
  user: state.user
});

export default withRouter(connect(mapStateToProps)(AuthGuard));
